import React from "react";
import { Redirect } from "react-router";
import Header from "../../Components/Admin/layout/header";
import DataTable from "react-data-table-component";
import ReactApexChart from "react-apexcharts";
import * as CONFIG from "../../Components/_config";
import axios from "axios";
import ls from "local-storage";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import $ from "jquery";
import FooterStrict from "../Dashboard/FooterStrict";

const getToday = () => new Date().toISOString().split("T")[0];

const getDaysAgo = (n) => {
  const d = new Date();
  d.setDate(d.getDate() - n);
  return d.toISOString().split("T")[0];
};

const fmtCurrency = (v) => `$${parseFloat(v || 0).toFixed(2)}`;
const fmtFileKB = (bytes) => `${(bytes / 1024).toFixed(1)} KB`;
const fmtDateTime = (s) => {
  if (!s) return "—";
  const hasTz = /Z|[+-]\d{2}:\d{2}$/.test(s);
  return new Date(s).toLocaleString("en-US", hasTz ? { timeZoneName: "short" } : {});
};

const parseFilename = (key) => {
  const name = key.split("/").pop().replace(".json", "");
  const parts = name.split("_");
  return { retailer: parts[0] || "—", basket_id: parts[1] || "—" };
};

const STATUS_COLORS = {
  SENT:             { bg: "#27ae60", label: "SENT" },
  FAILED:           { bg: "#e74c3c", label: "FAILED" },
  PAYMENT_RECEIVED: { bg: "#2980b9", label: "PAYMENT RECEIVED" },
  PAID_TO_RETAILER: { bg: "#8e44ad", label: "PAID TO RETAILER" },
};

const statusBadge = (status) => {
  const cfg = STATUS_COLORS[status] || { bg: "#95a5a6", label: status || "PENDING" };
  return (
    <span
      style={{
        background: cfg.bg,
        color: "#fff",
        borderRadius: "3px",
        padding: "2px 8px",
        fontSize: "11px",
        fontWeight: 600,
      }}
    >
      {cfg.label}
    </span>
  );
};

class InmarMonitor extends React.Component {
  constructor(props) {
    super(props);
    toast.configure();
    this.state = {
      accessDenied: false,
      sources: [],
      sourcesLoading: false,
      source: "INMAR",

      // Date range (summary + failed tabs)
      startDate: getDaysAgo(30),
      endDate: getToday(),

      // Summary (stat cards + chart)
      summaryTotals: null,
      summaryRows: [],
      summaryLoading: false,

      // Pending stat card (uses today's date, separate call)
      pendingCount: null,

      // Active tab
      activeTab: "failed",

      // DB-driven tabs (Failed / Payment Received / Paid to Retailer)
      // currentDbStatus drives which status= param is sent to the API
      currentDbStatus: "FAILED",
      failedLoading: false,
      failedRecords: [],
      failedTotal: 0,
      failedPage: 1,
      failedPageSize: 20,

      // Pending Baskets tab
      pendingDate: getToday(),
      pendingLoading: false,
      pendingBaskets: [],
      pendingLoaded: false,

      // Failure Files tab
      filesDate: getToday(),
      filesLoading: false,
      files: [],
      filesLoaded: false,

      // Basket Detail modal
      basketDetail: null,
      basketDetailLoading: false,

      // Retry confirm modal
      retryTarget: null, // { key, basket_id, retailer }
      retryLoading: false,
    };
  }

  componentDidMount() {
    this.loadSources();
  }

  loadSources = () => {
    this.setState({ sourcesLoading: true });
    axios
      .get(
        `${CONFIG.API_URL}coupon/monitoring/sources`,
        { headers: CONFIG.config_head.headers }
      )
      .then((res) => {
        const sources = res.data.Message.sources || [];
        const firstSource = sources[0]?.id || "INMAR";
        this.setState({ sources, sourcesLoading: false, source: firstSource }, () => {
          this.loadSummary();
          this.loadFailed();
          this.loadPendingCount();
        });
      })
      .catch((err) => {
        this.setState({ sourcesLoading: false });
        if (err?.response?.status === 403) {
          this.setState({ accessDenied: true });
        } else {
          // Fall back to defaults so the rest of the screen still works
          this.loadSummary();
          this.loadFailed();
          this.loadPendingCount();
        }
      });
  };

  changeSource = (newSource) => {
    const newSourceConfig = this.state.sources.find((s) => s.id === newSource) || {};
    const leavePending = !newSourceConfig.has_pending_baskets && this.state.activeTab === "pending";
    this.setState(
      {
        source: newSource,
        summaryTotals: null,
        summaryRows: [],
        pendingCount: null,
        failedRecords: [],
        failedTotal: 0,
        failedPage: 1,
        pendingBaskets: [],
        pendingLoaded: false,
        files: [],
        filesLoaded: false,
        activeTab: leavePending ? "failed" : this.state.activeTab,
        currentDbStatus: leavePending ? "FAILED" : this.state.currentDbStatus,
      },
      () => {
        this.loadSummary();
        this.loadFailed(1, null, this.state.currentDbStatus);
        this.loadPendingCount();
      }
    );
  };

  // ─── API calls ────────────────────────────────────────────────────────────

  loadSummary = () => {
    const { startDate, endDate, source } = this.state;
    this.setState({ summaryLoading: true });
    axios
      .get(
        `${CONFIG.API_URL}coupon/monitoring/summary?start_date=${startDate}&end_date=${endDate}&source=${source}`,
        { headers: CONFIG.config_head.headers }
      )
      .then((res) => {
        const msg = res.data.Message;
        // reverse so chart x-axis goes oldest → newest
        this.setState({
          summaryTotals: msg.totals,
          summaryRows: [...(msg.summary || [])].reverse(),
          summaryLoading: false,
        });
      })
      .catch((err) => {
        this.setState({ summaryLoading: false });
        if (err?.response?.status === 403) {
          this.setState({ accessDenied: true });
        } else {
          toast.error(err?.response?.data?.Message || "Failed to load summary");
        }
      });
  };

  loadPendingCount = () => {
    axios
      .get(
        `${CONFIG.API_URL}coupon/monitoring/pending?date=${getToday()}&source=${this.state.source}`,
        { headers: CONFIG.config_head.headers }
      )
      .then((res) => {
        this.setState({ pendingCount: res.data.Message.count });
      })
      .catch(() => {});
  };

  loadFailed = (page, pageSize, status) => {
    const { startDate, endDate, failedPage, failedPageSize, currentDbStatus, source } = this.state;
    const p = page || failedPage;
    const ps = pageSize || failedPageSize;
    const st = status || currentDbStatus || "FAILED";
    this.setState({ failedLoading: true });
    axios
      .get(
        `${CONFIG.API_URL}coupon/monitoring/records?start_date=${startDate}&end_date=${endDate}&page_no=${p}&page_size=${ps}&status=${st}&source=${source}`,
        { headers: CONFIG.config_head.headers }
      )
      .then((res) => {
        const msg = res.data.Message;
        this.setState((prev) => ({
          failedRecords: msg.records || [],
          // Only update total on page 1 (fresh load / filter change / tab switch).
          // Subsequent page clicks reuse the stored total so the page count stays stable.
          failedTotal: p === 1 ? (msg.total_records || 0) : prev.failedTotal,
          failedLoading: false,
        }));
      })
      .catch((err) => {
        this.setState({ failedLoading: false });
        toast.error(err?.response?.data?.Message || "Failed to load records");
      });
  };

  loadPending = () => {
    const { pendingDate, source } = this.state;
    this.setState({ pendingLoading: true });
    axios
      .get(
        `${CONFIG.API_URL}coupon/monitoring/pending?date=${pendingDate}&source=${source}`,
        { headers: CONFIG.config_head.headers }
      )
      .then((res) => {
        const msg = res.data.Message;
        this.setState({
          pendingBaskets: msg.baskets || [],
          pendingCount: msg.count || 0,
          pendingLoading: false,
          pendingLoaded: true,
        });
      })
      .catch((err) => {
        this.setState({ pendingLoading: false });
        toast.error(
          err?.response?.data?.Message || "Failed to load pending baskets"
        );
      });
  };

  loadFiles = () => {
    const { filesDate, source } = this.state;
    this.setState({ filesLoading: true });
    axios
      .get(
        `${CONFIG.API_URL}coupon/monitoring/failure-files?date=${filesDate}&source=${source}`,
        { headers: CONFIG.config_head.headers }
      )
      .then((res) => {
        const msg = res.data.Message;
        this.setState({
          files: msg.files || [],
          filesLoading: false,
          filesLoaded: true,
        });
      })
      .catch((err) => {
        this.setState({ filesLoading: false });
        toast.error(
          err?.response?.data?.Message || "Failed to load failure files"
        );
      });
  };

  openBasketDetail = (s3Key) => {
    this.setState({ basketDetailLoading: true, basketDetail: null });
    $("#inmarBasketDetailTrigger").trigger("click");
    axios
      .get(
        `${CONFIG.API_URL}coupon/monitoring/basket-detail?s3_key=${encodeURIComponent(s3Key)}&source=${this.state.source}`,
        { headers: CONFIG.config_head.headers }
      )
      .then((res) => {
        this.setState({
          basketDetail: res.data.Message,
          basketDetailLoading: false,
        });
      })
      .catch((err) => {
        this.setState({ basketDetailLoading: false });
        toast.error(
          err?.response?.data?.Message || "Failed to load basket detail"
        );
      });
  };

  openRetryConfirm = (key, basket_id, retailer) => {
    this.setState({ retryTarget: { key, basket_id, retailer } });
    $("#inmarRetryTrigger").trigger("click");
  };

  doRetry = () => {
    const { retryTarget } = this.state;
    if (!retryTarget) return;
    this.setState({ retryLoading: true });
    axios
      .post(
        `${CONFIG.API_URL}coupon/monitoring/retry`,
        JSON.stringify({ s3_key: retryTarget.key, source: this.state.source }),
        { headers: CONFIG.config_head.headers }
      )
      .then((res) => {
        const msg = res.data.Message;
        this.setState({ retryLoading: false, retryTarget: null });
        $("#inmarRetryCloseBtn").trigger("click");
        if (res.status === 207) {
          toast.warn(
            `Partially re-queued. Failed offer IDs: ${(
              msg.failed_offer_ids || []
            ).join(", ")}`
          );
        } else {
          toast.success(
            `Basket ${msg.basket_id} re-queued successfully (${msg.queued} offer(s))`
          );
        }
        this.loadFiles();
      })
      .catch((err) => {
        this.setState({ retryLoading: false });
        toast.error(err?.response?.data?.Message || "Retry failed");
      });
  };

  handleDateRangeApply = () => {
    this.setState({ failedPage: 1 }, () => {
      this.loadSummary();
      this.loadFailed(1, null, this.state.currentDbStatus);
    });
  };

  // Map tab key → API status value
  static DB_TAB_STATUS = {
    failed:           "FAILED",
    payment_received: "PAYMENT_RECEIVED",
    paid_to_retailer: "PAID_TO_RETAILER",
  };

  switchTab = (tab) => {
    const cfg = this.state.sources.find((s) => s.id === this.state.source) || {};
    if (tab === "pending" && !cfg.has_pending_baskets) return;
    const dbStatus = InmarMonitor.DB_TAB_STATUS[tab];
    if (dbStatus) {
      // DB-driven tab: reset page and reload with new status
      this.setState(
        { activeTab: tab, currentDbStatus: dbStatus, failedPage: 1 },
        () => this.loadFailed(1, null, dbStatus)
      );
    } else {
      this.setState({ activeTab: tab }, () => {
        if (tab === "pending" && !this.state.pendingLoaded) this.loadPending();
        if (tab === "files" && !this.state.filesLoaded) this.loadFiles();
      });
    }
  };

  // ─── Render ───────────────────────────────────────────────────────────────

  render() {
    const isLogged = ls.get("token");
    if (!isLogged) return <Redirect to="/login" />;

    const brands = ls.get("brands") || [];
    if (!brands.length || brands[0].scopes[0] !== "all") {
      return (
        <Redirect
          to={
            brands.length && brands[0].scopes.includes("wholesaler:user")
              ? "/wholesalerlist"
              : "/dashboard"
          }
        />
      );
    }

    const {
      startDate,
      endDate,
      source,
      sources,
      summaryTotals,
      summaryRows,
      summaryLoading,
      pendingCount,
      activeTab,
      currentDbStatus,
      failedLoading,
      failedRecords,
      failedTotal,
      failedPageSize,
      pendingDate,
      pendingLoading,
      pendingBaskets,
      filesDate,
      filesLoading,
      files,
      basketDetail,
      basketDetailLoading,
      retryTarget,
      retryLoading,
      accessDenied,
    } = this.state;

    if (accessDenied) {
      return (
        <>
          <Header />
          <section className="ContentBlock pt-24 pb-24 Main_Block">
            <div className="container-fluid">
              <div className="row justify-content-center mt-5">
                <div className="col-md-6 text-center">
                  <h4>Access Denied</h4>
                  <p>You do not have permission to view this page.</p>
                </div>
              </div>
            </div>
          </section>
        </>
      );
    }

    // ─── Source capability flags ──────────────────────────────────────────
    const currentSourceCfg = sources.find((s) => s.id === source) || {};
    const hasPendingBaskets = !!currentSourceCfg.has_pending_baskets;
    const hasBasketDetail   = !!currentSourceCfg.has_basket_detail;

    // ─── Chart data ───────────────────────────────────────────────────────
    const chartCategories = summaryRows.map((r) => r.report_date);
    const chartSeries = [
      {
        name: "Sent",
        type: "column",
        data: summaryRows.map((r) => r.sent || 0),
      },
      {
        name: "Failure Rate",
        type: "line",
        data: summaryRows.map((r) => {
          const sent = r.sent || 0;
          const failed = r.failed || 0;
          return sent > 0 ? parseFloat(((failed / sent) * 100).toFixed(2)) : 0;
        }),
      },
    ];
    const chartOptions = {
      chart: {
        type: "line",
        toolbar: { show: false },
        fontFamily: "inherit",
        animations: { enabled: true, speed: 500 },
      },
      colors: ["#3d8ecc", "#e74c3c"],
      stroke: { width: [0, 3], curve: "smooth" },
      markers: { size: [0, 4] },
      xaxis: {
        categories: chartCategories,
        labels: { rotate: -45, style: { fontSize: "11px" } },
      },
      yaxis: [
        {
          title: { text: "Sent Volume", style: { color: "#3d8ecc", fontSize: "12px" } },
          labels: { formatter: (v) => Math.round(v), style: { colors: ["#3d8ecc"] } },
          min: 0,
          forceNiceScale: true,
        },
        {
          opposite: true,
          title: { text: "Failure Rate %", style: { color: "#e74c3c", fontSize: "12px" } },
          labels: { formatter: (v) => v.toFixed(1) + "%", style: { colors: ["#e74c3c"] } },
          min: 0,
          forceNiceScale: true,
        },
      ],
      plotOptions: { bar: { columnWidth: "50%" } },
      dataLabels: { enabled: false },
      legend: { position: "bottom", horizontalAlign: "center" },
      tooltip: {
        shared: true,
        intersect: false,
        followCursor: true,
        y: [
          { formatter: (v) => v?.toLocaleString() },
          { formatter: (v) => v?.toFixed(2) + "%" },
        ],
      },
    };

    // ─── Table columns ────────────────────────────────────────────────────

    // Shared DB tab columns (Failed / Payment Received / Paid to Retailer)
    const dbTabColumns = [
      {
        name: "Date",
        selector: (r) => r.sent_at || r.modified_at,
        cell: (r) => fmtDateTime(r.sent_at || r.modified_at),
        sortable: true,
        wrap: true,
      },
      {
        name: "Redemption ID",
        selector: (r) => r.coupon_redemption_id,
        sortable: true,
      },
      {
        name: "Store",
        selector: (r) => r.store_identifier,
        sortable: true,
      },
      {
        name: "Transaction",
        selector: (r) => r.transaction_identifier,
        sortable: true,
      },
      {
        name: "Amount",
        selector: (r) => r.redemption_amount,
        cell: (r) => fmtCurrency(r.redemption_amount),
        sortable: true,
      },
      {
        name: "Status",
        selector: (r) => r.external_status,
        cell: (r) => statusBadge(r.external_status),
        sortable: true,
      },
      // Failure Reason only on the FAILED tab — null on PAYMENT_RECEIVED / PAID_TO_RETAILER
      ...(currentDbStatus === "FAILED"
        ? [
            {
              name: "Failure Reason",
              selector: (r) => r.failure_reason,
              cell: (r) =>
                r.failure_reason ? (
                  <span
                    style={{ color: "#c0392b", fontSize: "12px" }}
                    title={r.failure_reason}
                  >
                    {r.failure_reason.length > 80
                      ? r.failure_reason.slice(0, 80) + "…"
                      : r.failure_reason}
                  </span>
                ) : (
                  <span style={{ color: "#aaa", fontSize: "12px" }}>—</span>
                ),
              wrap: true,
              grow: 2,
            },
          ]
        : []),
    ];

    const pendingColumns = [
      { name: "Basket ID", selector: (r) => r.basket_id, sortable: true },
      {
        name: "Retailer (RSA ID)",
        selector: (r) => r.retailer_rsa_identifier,
        sortable: true,
      },
      {
        name: "Wholesaler",
        selector: (r) => r.wholesaler_name,
        sortable: true,
      },
      {
        name: "Transaction Time",
        selector: (r) => r.transaction_datetime,
        cell: (r) => fmtDateTime(r.transaction_datetime),
        sortable: true,
        wrap: true,
      },
      {
        name: "Offers Collected",
        selector: (r) => r.offer_count,
        sortable: true,
      },
      {
        name: "Actions",
        cell: (r) => (
          <button
            className="btn btn-sm"
            style={{
              fontSize: "12px",
              padding: "3px 12px",
              background: "#3d8ecc",
              color: "#fff",
              border: "none",
              borderRadius: "4px",
            }}
            onClick={() => this.openBasketDetail(r.s3_key)}
          >
            View Detail
          </button>
        ),
      },
    ];

    const filesColumns = [
      {
        name: "Time",
        selector: (r) => r.last_modified,
        cell: (r) => fmtDateTime(r.last_modified),
        sortable: true,
        wrap: true,
      },
      {
        name: "Retailer",
        selector: (r) => parseFilename(r.key).retailer,
        sortable: true,
      },
      {
        name: "Basket ID",
        selector: (r) => parseFilename(r.key).basket_id,
        sortable: true,
      },
      {
        name: "File Size",
        selector: (r) => r.size,
        cell: (r) => fmtFileKB(r.size),
        sortable: true,
      },
      {
        name: "Actions",
        cell: (r) => {
          const { retailer, basket_id } = parseFilename(r.key);
          return (
            <div>
              {hasBasketDetail && (
                <button
                  className="btn btn-sm"
                  style={{
                    fontSize: "12px",
                    padding: "3px 10px",
                    marginRight: "6px",
                    background: "#3d8ecc",
                    color: "#fff",
                    border: "none",
                    borderRadius: "4px",
                  }}
                  onClick={() => this.openBasketDetail(r.key)}
                >
                  View
                </button>
              )}
              <button
                className="btn btn-sm"
                style={{
                  fontSize: "12px",
                  padding: "3px 10px",
                  background: "#e74c3c",
                  color: "#fff",
                  border: "none",
                  borderRadius: "4px",
                }}
                onClick={() =>
                  this.openRetryConfirm(r.key, basket_id, retailer)
                }
              >
                Retry
              </button>
            </div>
          );
        },
      },
    ];

    // ─── Basket detail: join offers + db_statuses ─────────────────────────
    const statusMap = {};
    if (basketDetail?.db_statuses) {
      basketDetail.db_statuses.forEach((s) => {
        statusMap[s.coupon_redemption_id] = s;
      });
    }

    // ─── Failure reason (present when opened from a failure file) ─────────
    let failureErrorMsg = null;
    let failureHttpStatus = null;
    let failureTimestamp = null;
    if (basketDetail?.inmar_response || basketDetail?.inmar_http_status || basketDetail?.http_status) {
      failureHttpStatus = basketDetail.inmar_http_status || basketDetail.http_status || null;
      failureTimestamp = basketDetail.failed_at || basketDetail.modified_at || null;
      let raw = basketDetail.inmar_response || "";
      try {
        const parsed = JSON.parse(raw);
        failureErrorMsg = parsed.message || parsed.error || raw;
      } catch (_) {
        failureErrorMsg = raw;
      }
    }

    // ─── Date picker shared style ─────────────────────────────────────────
    const dateInput = {
      width: "145px",
      height: "32px",
      fontSize: "13px",
      border: "1px solid #ced4da",
      borderRadius: "4px",
      padding: "0 8px",
    };

    const applyBtn = {
      background: "#3d8ecc",
      borderColor: "#3d8ecc",
      color: "#fff",
      fontSize: "13px",
      padding: "4px 14px",
      borderRadius: "4px",
      border: "1px solid #3d8ecc",
      cursor: "pointer",
    };

    const tabBtn = (key, label) => (
      <li className="nav-item" key={key}>
        <button
          style={{
            background: "none",
            border: "none",
            borderBottom:
              activeTab === key
                ? "3px solid #3d8ecc"
                : "3px solid transparent",
            color: activeTab === key ? "#3d8ecc" : "#555",
            fontWeight: activeTab === key ? 600 : 400,
            padding: "10px 20px",
            cursor: "pointer",
            fontSize: "14px",
          }}
          onClick={() => this.switchTab(key)}
        >
          {label}
        </button>
      </li>
    );

    return (
      <>
        <Header />
        <section className="ContentBlock pt-24 pb-24 Main_Block">
          <div className="container-fluid">

            {/* ── Page header row with date range picker ── */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                flexWrap: "wrap",
                gap: "12px",
                marginBottom: "20px",
              }}
            >
              <h5 style={{ color: "#1a3a5c", fontWeight: 700, margin: 0 }}>
                External Redemption Monitor
              </h5>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  flexWrap: "wrap",
                }}
              >
                <label
                  style={{ fontSize: "13px", color: "#555", margin: 0 }}
                >
                  From
                </label>
                <input
                  type="date"
                  style={dateInput}
                  value={startDate}
                  max={endDate}
                  onChange={(e) => this.setState({ startDate: e.target.value })}
                />
                <label
                  style={{ fontSize: "13px", color: "#555", margin: 0 }}
                >
                  To
                </label>
                <input
                  type="date"
                  style={dateInput}
                  value={endDate}
                  min={startDate}
                  max={getToday()}
                  onChange={(e) => this.setState({ endDate: e.target.value })}
                />
                <button style={applyBtn} onClick={this.handleDateRangeApply}>
                  Apply
                </button>
              </div>
            </div>

            {/* ── Source selector (rendered only when > 1 source available) ── */}
            {sources.length > 1 && (
              <div style={{ display: "flex", alignItems: "center", gap: "0", marginBottom: "20px" }}>
                {sources.map((s, i) => (
                  <button
                    key={s.id}
                    onClick={() => s.id !== source && this.changeSource(s.id)}
                    style={{
                      padding: "7px 28px",
                      fontSize: "13px",
                      fontWeight: source === s.id ? 700 : 500,
                      background: source === s.id ? "#1a3a5c" : "#f0f4f8",
                      color: source === s.id ? "#fff" : "#555",
                      border: "1px solid #c8d6e4",
                      borderRadius:
                        i === 0
                          ? "6px 0 0 6px"
                          : i === sources.length - 1
                          ? "0 6px 6px 0"
                          : "0",
                      cursor: source === s.id ? "default" : "pointer",
                      transition: "all 0.15s",
                      letterSpacing: "0.5px",
                    }}
                  >
                    {s.label}
                  </button>
                ))}
              </div>
            )}

            {/* ── Stat cards ── */}
            <div className="row mb-3">
              {[
                {
                  label: "Total",
                  value: summaryLoading ? "…" : summaryTotals?.total ?? "—",
                  color: "#3d8ecc",
                },
                {
                  label: "Sent",
                  value: summaryLoading ? "…" : summaryTotals?.sent ?? "—",
                  color: "#27ae60",
                },
                {
                  label: "Failed",
                  value: summaryLoading ? "…" : summaryTotals?.failed ?? "—",
                  color: "#e74c3c",
                },
                {
                  label: "Payment Received",
                  value: summaryLoading ? "…" : summaryTotals?.payment_received ?? "—",
                  color: "#2980b9",
                },
                {
                  label: "Paid to Retailer",
                  value: summaryLoading ? "…" : summaryTotals?.paid_to_retailer ?? "—",
                  color: "#8e44ad",
                },
                {
                  label: "Pending",
                  value: pendingCount ?? "—",
                  color: "#f39c12",
                },
              ].map((c) => (
                <div className="col-xl-2 col-md-4 col-6 mb-3" key={c.label}>
                  <div
                    style={{
                      background: "#fff",
                      border: `2px solid ${c.color}`,
                      borderRadius: "8px",
                      padding: "20px 16px",
                      textAlign: "center",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "34px",
                        fontWeight: 700,
                        color: c.color,
                        lineHeight: 1.2,
                      }}
                    >
                      {c.value}
                    </div>
                    <div
                      style={{
                        fontSize: "13px",
                        color: "#666",
                        marginTop: "6px",
                      }}
                    >
                      {c.label}
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* ── Daily trend chart ── */}
            <div
              style={{
                background: "#fff",
                border: "1px solid #e8e8e8",
                borderRadius: "8px",
                padding: "16px 16px 4px",
                marginBottom: "20px",
                boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
              }}
            >
              <h6
                style={{
                  color: "#3d8ecc",
                  fontWeight: 600,
                  marginBottom: "12px",
                  fontSize: "14px",
                }}
              >
                Daily Volume &amp; Failure Rate
              </h6>
              {summaryRows.length > 0 ? (
                <ReactApexChart
                  type="line"
                  series={chartSeries}
                  options={chartOptions}
                  height={260}
                />
              ) : (
                <p
                  style={{
                    color: "#aaa",
                    margin: 0,
                    padding: "20px 0",
                    textAlign: "center",
                  }}
                >
                  {summaryLoading
                    ? "Loading chart…"
                    : "No data for selected date range."}
                </p>
              )}
            </div>

            {/* ── Tabs ── */}
            <div className="Coupons_Block">
              {/* Tab nav */}
              <div
                style={{
                  borderBottom: "2px solid #e0e8f0",
                  marginBottom: "0",
                }}
              >
                <ul
                  className="nav"
                  style={{ listStyle: "none", margin: 0, padding: 0, display: "flex", flexWrap: "wrap" }}
                >
                  {tabBtn("failed",           "Failed Redemptions")}
                  {tabBtn("payment_received", "Payment Received")}
                  {tabBtn("paid_to_retailer", "Paid to Retailer")}
                  {hasPendingBaskets && tabBtn("pending", "Pending Baskets")}
                  {tabBtn("files",            "Failure Files")}
                </ul>
              </div>

              {/* Tab body */}
              <div className="Common_Block_Body" style={{ padding: "20px" }}>

                {/* ── DB-driven tabs: Failed / Payment Received / Paid to Retailer ── */}
                {!!InmarMonitor.DB_TAB_STATUS[activeTab] && (
                  <div>
                    <p style={{ fontSize: "12px", color: "#888", marginBottom: "14px" }}>
                      {currentDbStatus === "FAILED" &&
                        "FAILED redemptions for the selected date range. Retry is available per-basket from the Failure Files tab."}
                      {currentDbStatus === "PAYMENT_RECEIVED" &&
                        "Redemptions where the provider has paid BrandIQ. Awaiting payment to the retailer."}
                      {currentDbStatus === "PAID_TO_RETAILER" &&
                        "Full payment cycle complete — the provider paid BrandIQ and BrandIQ paid the retailer."}
                    </p>
                    <DataTable
                      columns={dbTabColumns}
                      data={failedRecords}
                      progressPending={failedLoading}
                      pagination
                      paginationServer
                      paginationTotalRows={failedTotal}
                      paginationPerPage={failedPageSize}
                      onChangePage={(page) => {
                        this.setState({ failedPage: page }, () =>
                          this.loadFailed(page, null, currentDbStatus)
                        );
                      }}
                      onChangeRowsPerPage={(newPs, page) => {
                        this.setState(
                          { failedPageSize: newPs, failedPage: page },
                          () => this.loadFailed(page, newPs, currentDbStatus)
                        );
                      }}
                      noDataComponent={
                        <p style={{ padding: "24px", color: "#aaa" }}>
                          No records found.
                        </p>
                      }
                    />
                  </div>
                )}

                {/* ── Pending Baskets ── */}
                {activeTab === "pending" && (
                  <div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        marginBottom: "12px",
                        flexWrap: "wrap",
                      }}
                    >
                      <label
                        style={{
                          fontSize: "13px",
                          color: "#555",
                          margin: 0,
                        }}
                      >
                        Date
                      </label>
                      <input
                        type="date"
                        style={dateInput}
                        value={pendingDate}
                        max={getToday()}
                        onChange={(e) =>
                          this.setState({ pendingDate: e.target.value })
                        }
                      />
                      <button style={applyBtn} onClick={this.loadPending}>
                        Refresh
                      </button>
                    </div>
                    <p
                      style={{
                        fontSize: "12px",
                        color: "#888",
                        marginBottom: "14px",
                      }}
                    >
                      In-progress baskets collecting offers before sending to
                      the provider. Under normal conditions they clear within seconds.
                      A basket visible here for more than 5 minutes may warrant
                      investigation.
                    </p>
                    <DataTable
                      columns={pendingColumns}
                      data={pendingBaskets}
                      progressPending={pendingLoading}
                      pagination
                      noDataComponent={
                        <p style={{ padding: "24px", color: "#aaa" }}>
                          No pending baskets for this date.
                        </p>
                      }
                    />
                  </div>
                )}

                {/* ── Failure Files ── */}
                {activeTab === "files" && (
                  <div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        marginBottom: "12px",
                        flexWrap: "wrap",
                      }}
                    >
                      <label
                        style={{
                          fontSize: "13px",
                          color: "#555",
                          margin: 0,
                        }}
                      >
                        Date
                      </label>
                      <input
                        type="date"
                        style={dateInput}
                        value={filesDate}
                        max={getToday()}
                        onChange={(e) =>
                          this.setState({ filesDate: e.target.value })
                        }
                      />
                      <button style={applyBtn} onClick={this.loadFiles}>
                        Refresh
                      </button>
                    </div>
                    <DataTable
                      columns={filesColumns}
                      data={files}
                      progressPending={filesLoading}
                      pagination
                      noDataComponent={
                        <p style={{ padding: "24px", color: "#aaa" }}>
                          No failure files for this date.
                        </p>
                      }
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>

        <FooterStrict />

        {/* ── Basket Detail modal (hidden trigger) ── */}
        <button
          id="inmarBasketDetailTrigger"
          data-bs-toggle="modal"
          data-bs-target="#inmarBasketDetailModal"
          style={{ display: "none" }}
        />

        {/* ── Basket Detail modal ── */}
        <div
          className="modal fade"
          id="inmarBasketDetailModal"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex="-1"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
            <div className="modal-content">
              <div
                className="modal-header"
                style={{ background: "#1a3a5c", color: "#fff" }}
              >
                <h5 className="modal-title" style={{ color: "#fff" }}>
                  Basket Detail
                </h5>
                <button
                  type="button"
                  className="btn-close btn-close-white"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                />
              </div>
              <div className="modal-body">
                {basketDetailLoading ? (
                  <p className="text-center py-4" style={{ color: "#aaa" }}>
                    Loading…
                  </p>
                ) : basketDetail ? (
                  <>
                    {/* Basket header info */}
                    <div className="row mb-3">
                      <div className="col-md-6">
                        <table
                          style={{ fontSize: "13px", width: "100%", borderCollapse: "collapse" }}
                        >
                          <tbody>
                            {[
                              ["Basket ID", basketDetail.basket_id],
                              [
                                "Retailer",
                                basketDetail.retailer_rsa_identifier,
                              ],
                              ["Wholesaler", basketDetail.wholesaler_name],
                              [
                                "Transaction Time",
                                fmtDateTime(basketDetail.transaction_datetime),
                              ],
                            ].map(([label, val]) => (
                              <tr key={label}>
                                <td
                                  style={{
                                    color: "#888",
                                    paddingRight: "14px",
                                    paddingBottom: "8px",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  {label}
                                </td>
                                <td
                                  style={{
                                    fontWeight: label === "Basket ID" ? 700 : 400,
                                    paddingBottom: "8px",
                                  }}
                                >
                                  {val}
                                </td>
                              </tr>
                            ))}
                            <tr>
                              <td
                                style={{
                                  color: "#888",
                                  paddingRight: "14px",
                                }}
                              >
                                Sent to Provider
                              </td>
                              <td>
                                {basketDetail.SentToInmar ? (
                                  <span
                                    style={{
                                      background: "#27ae60",
                                      color: "#fff",
                                      borderRadius: "3px",
                                      padding: "2px 8px",
                                      fontSize: "11px",
                                      fontWeight: 600,
                                    }}
                                  >
                                    YES
                                  </span>
                                ) : (
                                  <span
                                    style={{
                                      background: "#e74c3c",
                                      color: "#fff",
                                      borderRadius: "3px",
                                      padding: "2px 8px",
                                      fontSize: "11px",
                                      fontWeight: 600,
                                    }}
                                  >
                                    NO
                                  </span>
                                )}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>

                    {/* Failure Reason card — only shown when failure info is present */}
                    {(failureErrorMsg || failureHttpStatus) && (
                      <div
                        style={{
                          border: "1px solid #f5c6cb",
                          borderLeft: "5px solid #e74c3c",
                          borderRadius: "6px",
                          background: "#fff8f8",
                          padding: "14px 18px",
                          marginBottom: "18px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            marginBottom: "12px",
                          }}
                        >
                          <span
                            style={{
                              color: "#e74c3c",
                              fontWeight: 700,
                              fontSize: "15px",
                            }}
                          >
                            &#10007;
                          </span>
                          <span
                            style={{
                              color: "#c0392b",
                              fontWeight: 700,
                              fontSize: "14px",
                            }}
                          >
                            Failure Reason
                          </span>
                        </div>
                        <table style={{ fontSize: "13px", borderCollapse: "collapse", width: "100%" }}>
                          <tbody>
                            {failureHttpStatus && (
                              <tr>
                                <td
                                  style={{
                                    color: "#888",
                                    paddingRight: "16px",
                                    paddingBottom: "6px",
                                    whiteSpace: "nowrap",
                                    verticalAlign: "top",
                                  }}
                                >
                                  HTTP Status
                                </td>
                                <td style={{ paddingBottom: "6px" }}>
                                  <strong>{failureHttpStatus}</strong>
                                </td>
                              </tr>
                            )}
                            {failureErrorMsg && (
                              <tr>
                                <td
                                  style={{
                                    color: "#888",
                                    paddingRight: "16px",
                                    paddingBottom: "6px",
                                    whiteSpace: "nowrap",
                                    verticalAlign: "top",
                                  }}
                                >
                                  Error
                                </td>
                                <td
                                  style={{
                                    color: "#c0392b",
                                    paddingBottom: "6px",
                                    wordBreak: "break-word",
                                  }}
                                >
                                  {failureErrorMsg}
                                </td>
                              </tr>
                            )}
                            {failureTimestamp && (
                              <tr>
                                <td
                                  style={{
                                    color: "#888",
                                    paddingRight: "16px",
                                    whiteSpace: "nowrap",
                                    verticalAlign: "top",
                                  }}
                                >
                                  Failed at
                                </td>
                                <td>{fmtDateTime(failureTimestamp)}</td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    )}

                    {/* Offers table */}
                    <h6
                      style={{
                        fontWeight: 600,
                        color: "#1a3a5c",
                        borderBottom: "1px solid #e0e8f0",
                        paddingBottom: "6px",
                        marginBottom: "12px",
                      }}
                    >
                      Offers
                    </h6>
                    <div className="table-responsive">
                      <table
                        className="table table-sm"
                        style={{ fontSize: "12px" }}
                      >
                        <thead>
                          <tr
                            style={{
                              background: "#1a3a5c",
                              color: "#fff",
                            }}
                          >
                            <th style={{ color: "#fff", padding: "8px 10px" }}>
                              Offer GUID
                            </th>
                            <th style={{ color: "#fff", padding: "8px 10px" }}>
                              Coupon ID
                            </th>
                            <th style={{ color: "#fff", padding: "8px 10px" }}>
                              Redemption ID
                            </th>
                            <th style={{ color: "#fff", padding: "8px 10px" }}>
                              Amount
                            </th>
                            <th style={{ color: "#fff", padding: "8px 10px" }}>
                              Applied
                            </th>
                            <th style={{ color: "#fff", padding: "8px 10px" }}>
                              Status
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {(basketDetail.offers || []).map((o, i) => {
                            const dbStatus =
                              statusMap[o.coupon_redemption_id];
                            return (
                              <tr key={i}>
                                <td
                                  style={{
                                    wordBreak: "break-all",
                                    maxWidth: "200px",
                                    padding: "7px 10px",
                                  }}
                                >
                                  {o.offer_guid}
                                </td>
                                <td style={{ padding: "7px 10px" }}>
                                  {o.coupon_id}
                                </td>
                                <td style={{ padding: "7px 10px" }}>
                                  {o.coupon_redemption_id}
                                </td>
                                <td style={{ padding: "7px 10px" }}>
                                  {fmtCurrency(o.redemption_amount)}
                                </td>
                                <td style={{ padding: "7px 10px" }}>
                                  {o.applied_count}
                                </td>
                                <td style={{ padding: "7px 10px" }}>
                                  {statusBadge(dbStatus?.external_status)}
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </>
                ) : (
                  <p
                    className="text-center py-4"
                    style={{ color: "#aaa" }}
                  >
                    No data available.
                  </p>
                )}
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* ── Retry Confirm modal (hidden trigger) ── */}
        <button
          id="inmarRetryTrigger"
          data-bs-toggle="modal"
          data-bs-target="#inmarRetryModal"
          style={{ display: "none" }}
        />

        {/* ── Retry Confirm modal ── */}
        <div
          className="modal fade Confirmation_Modal"
          id="inmarRetryModal"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex="-1"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body text-center p-4">
                <i
                  className="fas fa-exclamation-triangle"
                  style={{ fontSize: "32px", color: "#f39c12" }}
                />
                <h5 className="mt-3 fw-bold">Re-queue Basket?</h5>
                {retryTarget && (
                  <p style={{ color: "#555", margin: "10px 0 0" }}>
                    Re-queue basket{" "}
                    <strong>{retryTarget.basket_id}</strong> for retailer{" "}
                    <strong>{retryTarget.retailer}</strong> to {source}? This
                    will re-attempt the tlog submission.
                  </p>
                )}
              </div>
              <div
                className="modal-footer"
                style={{ justifyContent: "center" }}
              >
                <button
                  type="button"
                  className="btn btn-primary"
                  style={{
                    background: "#3d8ecc",
                    borderColor: "#3d8ecc",
                    minWidth: "120px",
                  }}
                  onClick={this.doRetry}
                  disabled={retryLoading}
                >
                  {retryLoading ? "Submitting…" : "Yes, Re-queue"}
                </button>
                <button
                  id="inmarRetryCloseBtn"
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default InmarMonitor;
